import React from 'react'
import { observer } from 'mobx-react-lite'
import MaxAvDateStore from './../../store/max-av-date.store'
import SalesTrackerStore from './../../store'
import { MDBIcon, MDBCollapse } from 'mdb-react-ui-kit'
import CustomAlert from './../../../../components/shared/CustomAlert'
import UserProfileService from '../../../../shared/services/UserProfile.service'

import './MaxAvAgeAlert.component.scss'

export default observer(() => {
  const { isAgeRestricted, isPreviousYearLocked, isAgeMonthsLocked, ageSetting } = MaxAvDateStore,
    isAdmin = UserProfileService.isA(['internal-admin', 'internal-staff', 'system-admin', 'agency-owner'], true)

  const message = isPreviousYearLocked
    ? isAdmin
      ? 'Agent cannot modify this policy — previous year is closed for business. BST must enable “Allow edit beyond current year” for the agent to edit.'
      : 'This policy cannot be modified — previous year is closed for business. Contact BST if you need to edit.'
    : isAgeMonthsLocked
    ? isAdmin
      ? `Agent cannot modify this policy due to its age. Policies over ${ageSetting} months are locked.`
      : `This policy cannot be modified due to its age. Policies over ${ageSetting} months are locked.`
    : null

  return (
    <div id='MaxAvAgeAlertComponent'>
      <MDBCollapse open={!!isAgeRestricted && !SalesTrackerStore?.isFetching}>
        <CustomAlert color='warning'>
          <div>
            <h6>
              <MDBIcon icon='exclamation-triangle' />
              &nbsp;
              {isPreviousYearLocked ? 'Previous year locked' : 'Max AV date'}
            </h6>
            {message}
          </div>
        </CustomAlert>
      </MDBCollapse>
    </div>
  )
})
